import PropTypes from 'prop-types';
// Import Components
import CustomerOnBoardActivityChart from 'components/Dashboard/CustomerOnBoardActivityChart';
import DailyActiveCustomersByProductChart from 'components/Dashboard/DailyActiveCustomersByProductChart';
import DailyCommunicationMetricsChart from 'components/Dashboard/DailyCommunicationMetricsChart';
import ConversionTimeAnalyticsChart from 'components/Dashboard/ConversionTimeAnalyticsChart';
import LinkOpenClickPerformanceChart from './LinkOpenClickPerformanceChart';
// Import Constants
import { Widgets } from 'constants/common';

const ChartsSection = ({ parentDate, possibleWidgets }) => {
    return (
        <>
            <div className="charts-wrap">
                {possibleWidgets.includes(Widgets.DailyMetricsForNewClients) && (
                    <div className="charts-wrap-inner">
                        <CustomerOnBoardActivityChart parentDate={parentDate} />
                    </div>
                )}
                {possibleWidgets.includes(Widgets.DailyActivityMetricsByProducts) && (
                    <div className="charts-wrap-inner">
                        <DailyActiveCustomersByProductChart parentDate={parentDate} />
                    </div>
                )}
                {possibleWidgets.includes(Widgets.ConversionTimeAnalysis) && (
                    <div className="charts-wrap-inner">
                        <ConversionTimeAnalyticsChart parentDate={parentDate} />
                    </div>
                )}
                {possibleWidgets.includes(Widgets.ConversionTimeAnalysis) && (
                    <div className="charts-wrap-inner">
                        <DailyCommunicationMetricsChart parentDate={parentDate} />
                    </div>
                )}
                {possibleWidgets.includes(Widgets.LinkOpenClickPerformance) && (
                    <div className="charts-wrap-inner full-width-chart">
                        <LinkOpenClickPerformanceChart parentDate={parentDate} />
                    </div>
                )}
            </div>
        </>
    );
};

ChartsSection.propTypes = {
    parentDate: PropTypes.array.isRequired,
    possibleWidgets: PropTypes.array,
};

ChartsSection.defaultProps = {
    possibleWidgets: [],
};

export default ChartsSection;
